import { APIData, appFetch } from ".";

export interface Job {
  id: number;
  title: string;
  description: string;
  location: string;
  type: string;
  is_active: boolean;
  created_at: string;
}

export interface JobApp {
  job_id: number;
  country_id: number;
  name: string;
  email: string;
  phone: string;
  birth_date: string;
  cv: string;
}

export const jobsAPI = {
  fetchPage(page: number) {
    return appFetch<APIData<Job[]>>("/jobs?page=" + page);
  },
  submitJobApp(data: JobApp) {
    return appFetch<APIData<{ message: string }>>("/submit-job-application", {
      headers: {
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(data),
    });
  },
};
